import { createReducer, on } from '@ngrx/store';

import {
  ClearAuthenticationStatus,
  SetAuthenticationStatus,
} from '../../actions/auth/auth.actions';

export interface AuthState {
  isAuthenticated: boolean;
  authCheckCompleted: boolean;
}

export const initialState: AuthState = {
  isAuthenticated: false,
  authCheckCompleted: false,
};

export const authReducer = createReducer(
  initialState,
  on(SetAuthenticationStatus, (state, { isAuthenticated }) => ({
    ...state,
    isAuthenticated,
    authCheckCompleted: true,
  })),
  on(ClearAuthenticationStatus, () => initialState),
);
